import { useEffect, useState } from "react";
import useDebouncedValue from "./useDebouncedValue";

export const TABLE_SEARCH_DEBOUNCE_MS = 300;
export const TABLE_SEARCH_MIN_LENGTH = 2;

/**
 * Shared admin table search: responsive input + debounced API query (min length).
 * Empty / short queries yield `activeSearch === ""` so callers omit the search param.
 */
export default function useTableSearch({
  delayMs = TABLE_SEARCH_DEBOUNCE_MS,
  minLength = TABLE_SEARCH_MIN_LENGTH,
  onActiveSearchChange,
} = {}) {
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebouncedValue(searchQuery, delayMs);

  const activeSearch =
    debouncedSearchQuery.trim().length >= minLength
      ? debouncedSearchQuery.trim()
      : "";

  useEffect(() => {
    onActiveSearchChange?.(activeSearch);
  }, [activeSearch, onActiveSearchChange]);

  const clearSearch = () => setSearchQuery("");

  return {
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    activeSearch,
    clearSearch,
    hasActiveSearch: activeSearch !== "",
  };
}
